/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { EllipseProps } from '#utils/UNSAFE_visTypes/common';

export const Ellipse = ({
  cx,
  cy,
  rx,
  ry,
  scaleX,
  scaleY,
  tx,
  ty,
  fill,
  stroke,
  strokeWidth = 1,
  dataInfo,
  isInteractive,
  styleClass
}: EllipseProps) => {
  return (
    <ellipse
      {...dataInfo}
      cx={cx + tx}
      cy={cy + ty}
      rx={rx * scaleX}
      ry={ry * scaleY}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      cursor={isInteractive ? 'pointer' : undefined}
      vectorEffect="non-scaling-stroke"
      className={styleClass}
    />
  );
};
